<div class="form-group">
  <label for="{{className}}" ngClass="{'label-style': !basicStyle , 'control-label' : basicStyle">{{label }}</label>
  <input id="{{className}}" type="checkbox" name="has_paiement"
         class="{{className}}">

</div>
